import {connect} from "react-redux";
import BusinessConfigInspection from "./businessConfigInspection";
import {bindActionCreators} from "redux";
import {viewInspectionForm} from "../../../service/Lead/action";

const mapStateToProps = (state) => ({
    lead:state.Lead.lead,
    inspectionForm:state.Lead.inspectionForm,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewInspectionForm
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BusinessConfigInspection);
